import type { ReactNode } from 'react';
import {
  IconOutlineDatabase,
  IconOutlineTerminal,
  IconOutlineViewGrid,
  IconSolidDocumentText,
  IconSolidGithub,
  IconSolidGlobeAlt,
  IconSolidPencil,
  IconSolidSearch,
  IconSolidTerminal,
} from '@gonfalon/observability-ui/components/icons';
import { Icon } from '@launchpad-ui/icons';

import type { ToolClass } from './activityGrouping';

export const TOOL_CLASS_ICON: Record<ToolClass, ReactNode> = {
  vcs: <IconSolidGithub size={13} />,
  shell: <IconSolidTerminal size={13} />,
  search: <IconSolidSearch size={13} />,
  files: <IconOutlineViewGrid size={13} />,
  read: <IconSolidDocumentText size={13} />,
  write: <IconSolidPencil size={13} />,
  skill: <Icon name="tools" size="tiny" />,
  flags: <Icon name="osmo" size="tiny" />,
  db: <IconOutlineDatabase size={13} />,
  api: <IconSolidGlobeAlt size={13} />,
  other: <IconOutlineTerminal size={13} />,
};

export const commandGroupIcon = (toolClass: ToolClass | undefined): ReactNode =>
  toolClass ? TOOL_CLASS_ICON[toolClass] : <Icon name="stack" size="tiny" />;
